import Settings from "Data/Settings";
import { Sine, TimelineLite, TweenMax } from "gsap";
import * as HLF from "html-living-framework";
import * as Topics from "Data/Topics";
import {DWELL_DURATION} from "Data/Constants";
import { Button } from "GameObjects/UI/Button";
import { Text } from "GameObjects/UI/Text";
import * as Constants from "Data/Constants";
import * as VO from "Data/VoiceOver";
import { LayoutSprite } from "GameObjects/UI/LayoutSprite";

/** Accessible panel for SettingsPopup */
export class Panel extends LayoutSprite {
    protected _infoVO: string | undefined;
    protected _hitArea!: PIXI.Rectangle | PIXI.Circle | PIXI.Ellipse |
                        PIXI.Polygon | PIXI.RoundedRectangle | PIXI.IHitArea;

    protected _title: Text;
    protected _infoButton?: Button;
    protected _subscriptions: any[] = [];

    constructor (
        pTitle: string,
        pTitleVO: string,
        pInfoVO: string,
    ) {
        super();
        this._infoVO = pInfoVO;

        this._title = this.addChild(new Text(pTitle.toUpperCase(), Constants.FONT_RIFFICFREE_BOLD_36, 36, new PIXI.Point(0, 0.5), pTitleVO, pInfoVO))
        this.addChild(this._title);

        this.interactive = true;
        this.buttonMode = false;

        this.on(HLF.Input.Events.POINTER_OVER, this.onPointerOver);
        this.on(HLF.Input.Events.POINTER_DOWN, this.onPointerDown);
        this.on(HLF.Input.Events.POINTER_UP, this.onPointerUp);
        this.on(HLF.Input.Events.POINTER_OUT, this.onPointerOut);

        this._subscriptions.push(
            PubSub.subscribe(Topics.SETTINGS_CHANGED, this.onSettingsChanged.bind(this)),
        );
    }

    public get title() {
        return this._title;
    }

    public destroy(pOptions?: Parameters<typeof PIXI.Container.prototype.destroy>[0]): void {
        super.destroy(pOptions);
        this._subscriptions.forEach(PubSub.unsubscribe);
    }

    public setLayoutTexture(texture: string | PIXI.Texture, anchorX: number, anchorY: number) {
        super.setLayoutTexture(texture, anchorX, anchorY);
    }

    public onLayout() {
        super.onLayout();
        this._title.scale.set(1 / this.scale.x, 1 / this.scale.y); // preserve aspect ratio
        this._title.position.set(((-this.width / 2) + 24) / this.scale.x, (-this.height / 2 + 36) / this.scale.y);
        this._title.setWidth((this.width / this.scale.x) - 24);
    }

    protected onPointerOver(pEvent: PIXI.InteractionEvent): void {
        //
    }

    protected onPointerDown(pEvent: PIXI.InteractionEvent): void {
        //
    }

    protected onPointerUp(pEvent: PIXI.InteractionEvent): void {
        //
    }

    protected onPointerOut(pEvent: PIXI.InteractionEvent): void {
        //
    }

    protected onSettingsChanged(pTopic: typeof Topics.SETTINGS_CHANGED, pSettings: Readonly<typeof Settings>): void {
        this._title.x = ((-this.width / 2) + 24) / this.scale.x;
        this._title.setWidth((this.width / this.scale.x) - 24);
    }
}
